// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_MANAGEMENT } from '../../../routes/paths';
import { PermissionPath } from '../../../components/permission/PermissionPath';
import { can } from 'src/components/permission/Permission';

export const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  discount: getIcon('ic_discount_circle'),
  advertisement: getIcon('ic_advertising'),
  invoice: getIcon('ic_order'),
  product_category: getIcon('ic_category'),
  setting: getIcon('ic_settings'),
  role: getIcon('ic_permission'),
  settlement: getIcon('ic_financial'),
  price: getIcon('ic_price'),
  shop: getIcon('ic_shop'),
  courier: getIcon('ic_courier'),
  comment: getIcon('ic_comment'),
  activity: getIcon('ic_active'),
  credit: getIcon('ic_credit'),
  report: getIcon('ic_report_admin'),
  message: getIcon('ic_message'),
  pro: getIcon('ic_pro'),
  proDiscount: getIcon('ic_discount'),
};

const sidebarConfig = [
  {
    subheader: 'قزوین فود',
    items: [
      {
        title: 'داشبورد',
        path: '/dashboard',
        icon: ICONS.dashboard,
      },
    ],
  },
  {
    subheader: 'مدیریت',
    items: [
      {
        title: 'کارمندان',
        path: PATH_MANAGEMENT.management.user.root,
        icon: ICONS.user,
        permissions: [PermissionPath.courier.index || PermissionPath.role.index],
        children: [
          {
            title: 'کاربران',
            path: PATH_MANAGEMENT.management.user.root,
            icon: ICONS.user,
            permissions: [PermissionPath.user.index],
          },

          {
            title: 'نقش ها',
            path: PATH_MANAGEMENT.management.role.root,
            icon: ICONS.role,
            permissions: [PermissionPath.role.index],
          },
        ],
      },

      {
        title: 'واحد ها',
        path: PATH_MANAGEMENT.management.root,
        icon: ICONS.shop,
        permissions: PermissionPath.shop.index,
        children: [
          {
            title: 'نمایش واحدها',
            path: PATH_MANAGEMENT.management.shops,
            permissions: PermissionPath.shop.index,
          },
          {
            title: 'تعطیلی واحدها',
            path: PATH_MANAGEMENT.management.closureShops,
            // permissions: PermissionPath.shop.index,
          },
          {
            title: 'ایجاد واحد',
            path: PATH_MANAGEMENT.management.newShop,
            permissions: PermissionPath.shop.store,
          },
          {
            title: 'دسته بندی واحدها',
            path: PATH_MANAGEMENT.management.shopCategory,
            permissions: PermissionPath.shopCategory.index,
          },
          {
            title: 'دسته بندی محصولات',
            path: PATH_MANAGEMENT.management.product_category.root,
            icon: ICONS.product_category,
            permissions: [PermissionPath.productCategory.index],
          },
          {
            title: 'دسته بندی برجسته',
            path: PATH_MANAGEMENT.management.shopCategoryHighlight,
            permissions: PermissionPath.shopCategoryHighlight.index,
          },
          {
            title: 'وعده های غذایی',
            path: PATH_MANAGEMENT.management.mealTags,
            permissions: PermissionPath.shopCategory.index,
          },
          {
            title: 'پیام رسان',
            path: PATH_MANAGEMENT.management.messenger.root,
            icon: ICONS.message,
            permissions: [PermissionPath.Messenger.index],
          },
        ],
      },
      {
        title: 'سفارشات',
        path: PATH_MANAGEMENT.management.invoice.root,
        icon: ICONS.invoice,
        permissions: [PermissionPath.invoice.index || PermissionPath.delayInvoice.index],
        children: [
          {
            title: 'اعلام',
            path: PATH_MANAGEMENT.management.invoice.root,
            permissions: PermissionPath.invoice.index,
          },
          {
            title: 'پشتیبانی',
            path: PATH_MANAGEMENT.management.delay_invoice.root,
            permissions: PermissionPath.delayInvoice.index,
          },
        ],
      },
      {
        title: 'امور مالی',
        path: PATH_MANAGEMENT.management.settlement.root,
        icon: ICONS.settlement,
        permissions: [PermissionPath.transaction.index || PermissionPath.settlement.index],
        children: [
          {
            title: 'واریزی ها-روش کیف پول',
            path: PATH_MANAGEMENT.management.settlement.root,
            permissions: PermissionPath.settlement.index,
          },
          {
            title: 'واریزی ها-روش تجمیعی',
            path: PATH_MANAGEMENT.management.settlementAccumulative.root,
            permissions: PermissionPath.settlement_accumulative.index,
          },

          {
            title: 'تراکنش ها',
            path: PATH_MANAGEMENT.management.transaction.root,
            permissions: PermissionPath.transaction.index,
          },
          {
            title: ' تراکنش های کیف پول',
            path: PATH_MANAGEMENT.management.walletPayment.root,
            permissions: 'wallet-payment.index',
          },
          {
            title: 'گزارش اداره مالیات',
            path: PATH_MANAGEMENT.management.taxes.root,
            permissions: [PermissionPath.CreditService.index],
          },
          {
            title: 'گزارش پرداختی‌های خیریه',
            path: PATH_MANAGEMENT.management.reports.charityDonations,
            icon: ICONS.report,
            permissions: [PermissionPath.Reports.index],
          },
        ],
      },
      {
        title: 'پیک ها',
        path: PATH_MANAGEMENT.management.courier.root,
        icon: ICONS.courier,
        permissions: [PermissionPath.courier.index || 'geofence.index'],
        children: [
          {
            title: 'نمایش پیک ها',
            path: PATH_MANAGEMENT.management.courier.root,
            permissions: ['courier.index'],
          },

          {
            title: 'حصار جغرافیایی',
            path: PATH_MANAGEMENT.management.geofance,
            permissions: ['geofence.index'],
          },
        ],
      },
      {
        title: 'قزوین پرو',
        path: PATH_MANAGEMENT.management.qazvinProPlan.root,
        icon: ICONS.pro,
        permissions: [PermissionPath.qazvinProPlan.index || PermissionPath.qazvinProBenefitPool.index],
        children: [
          {
            title: 'پلن های پرو',
            path: PATH_MANAGEMENT.management.qazvinProPlan.root,
            icon: ICONS.pro,
            permissions: [PermissionPath.qazvinProPlan.index],
          },
          {
            title: 'کدهای تخفیف پرو',
            path: PATH_MANAGEMENT.management.qazvinProBenefitPool.root,
            icon: ICONS.proDiscount,
            permissions: [PermissionPath.qazvinProBenefitPool.index],
          },
        ],
      },
      {
        title: 'گزارشات',
        path: PATH_MANAGEMENT.management.reports.root,
        icon: ICONS.report,
        permissions: [PermissionPath.Reports.index || PermissionPath.ActivityReport.index],
        children: [
          {
            title: 'گزارشات واحدها',
            path: PATH_MANAGEMENT.management.reports.root,
            exact: true,
            icon: ICONS.report,
            permissions: [PermissionPath.Reports.index],
          },
          {
            title: 'گزارش فعالیت',
            path: PATH_MANAGEMENT.management.activity.root,
            icon: ICONS.activity,
            permissions: [PermissionPath.ActivityReport.index],
          },
        ],
      },
      {
        title: 'تخفیف ها',
        path: PATH_MANAGEMENT.management.discountCode.root,
        icon: ICONS.discount,
        permissions: [PermissionPath.discountcode.index],
      },

      {
        title: 'تبلیغات',
        path: PATH_MANAGEMENT.management.advertisement.root,
        icon: ICONS.advertisement,
        permissions: [PermissionPath.advertisement.index],
      },

      {
        title: 'تنظیمات',
        path: PATH_MANAGEMENT.management.setting.root,
        icon: ICONS.setting,
        permissions: ['app-setting.get-config'],
      },

      {
        title: 'گردونه کش‌بک',
        path: PATH_MANAGEMENT.management.cashbackSegments.root,
        icon: ICONS.discount,
        permissions: [PermissionPath.cashbackSegments.show],
      },

      // {
      //   title: 'تایید قیمت',
      //   path: PATH_MANAGEMENT.management.priceChange,
      //   icon: ICONS.price,
      //   permissions: [PermissionPath.price.index],
      // },
      // {
      //   title: 'نظرات',
      //   path: PATH_MANAGEMENT.management.comment.root,
      //   icon: ICONS.comment,
      //   permissions: [PermissionPath.comment.index],
      // },
      {
        title: 'سرویس اعتباری',
        path: PATH_MANAGEMENT.management.credit.root,
        icon: ICONS.credit,
        permissions: [PermissionPath.CreditService.index],
      },
    ],
  },
];

export default sidebarConfig;
